import { RouteRecordRaw } from 'vue-router';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { VIEW_MODE } from '@/common/define/common.define';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { BASE_MENU_VALUE } from '@/common/components/organisms/baseMenu/baseMenu.define';
import {
  requireAuth,
  requireDomainTargetOrTutorial,
  requireInstances,
  setDayjsTimezone,
  validateDatabaseOverviewPath,
} from '@/common/router/authGuard';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX_SINGLESTORE = 'singlestore_';

const singlestoreMenu: RouteRecordRaw[] = [
  {
    path: '/singlestore/',
    name: `${PREFIX_SINGLESTORE}Real Time Monitoring`,
    component: BaseViewport,
    children: [
      {
        path: 'clusterView',
        name: `${PREFIX_SINGLESTORE}Cluster View`,
        component: () =>
          import('@/database/views/multiView/singleStore/SingleStoreClusterView.vue'),
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [
      requireAuth,
      () => requireDomainTargetOrTutorial('database'),
      setDayjsTimezone,
      requireInstances,
      validateDatabaseOverviewPath,
    ],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.DASHBOARD.DASHBOARD_FEATURED_DASHBOARD,
      invisibleViewMode: [VIEW_MODE.INTERMAX],
      viewport: VIEWPORT_TYPE.REALTIME,
    },
  },
  {
    path: '/singlestore/',
    name: `${PREFIX_SINGLESTORE}SQL Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'topNAnalysis',
        name: `${PREFIX_SINGLESTORE}Top N Analysis`,
        component: () => import('@/database/views/topNAnalysis/singlestore/TopNAnalysis.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_SINGLESTORE_PA,
        [VIEW_MODE.MAXGAUGE]:
          ROLE_PERMISSION_KEY.MONITORING.MONITORING_SINGLESTORE_PERFORMANCE_ANALYSIS,
      },
      invisibleViewMode: [VIEW_MODE.INTERMAX],
      viewport: VIEWPORT_TYPE.PA,
    },
  },
  {
    path: '/singlestore/',
    name: `${PREFIX_SINGLESTORE}Performance Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'trendAnalysis',
        name: `${PREFIX_SINGLESTORE}Trend Analysis`,
        component: () => import('@/database/views/trendAnalysis/singlestore/TrendAnalysis.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_SINGLESTORE_PA,
        [VIEW_MODE.MAXGAUGE]:
          ROLE_PERMISSION_KEY.MONITORING.MONITORING_SINGLESTORE_PERFORMANCE_ANALYSIS,
      },
      invisibleViewMode: [VIEW_MODE.INTERMAX],
      viewport: VIEWPORT_TYPE.PA,
    },
  },
];

const subMenuMappingSingleStore = {
  instanceView: `${PREFIX_SINGLESTORE}Real Time Monitoring`,
  sqlAnalysis: `${PREFIX_SINGLESTORE}SQL Analysis`,
  performanceAnalysis: `${PREFIX_SINGLESTORE}Performance Analysis`,
};

const getSingleStoreNaviMenu = (subMenu?: string) => {
  const filteredSingleStoreMenu = extractAccessibleRoutes(singlestoreMenu);
  if (subMenu && subMenuMappingSingleStore[subMenu]) {
    return filteredSingleStoreMenu.filter(
      (menu) => menu.name === subMenuMappingSingleStore[subMenu],
    );
  }

  return filteredSingleStoreMenu.filter(
    (menu) => menu.name !== subMenuMappingSingleStore.instanceView,
  );
};

export { singlestoreMenu, getSingleStoreNaviMenu, PREFIX_SINGLESTORE };
